import { render, staticRenderFns } from "./SubelementShowElementsTab.vue?vue&type=template&id=2d7307dc"
import script from "./SubelementShowElementsTab.vue?vue&type=script&lang=ts"
export * from "./SubelementShowElementsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports